import { useEffect, useState } from "react"
import { useThrottle } from "../../../../hooks/useThrottle"
import { setCurrentSearchUsername } from "../../../../store/messagingSlice"
import { FocusHandler } from "./FocusHandler"
import type {
    ThreadSearchViewModel,
    ThreadSearchViewModelPros,
} from "./ThreadSearchTypes"

export const UnifiedDesktopViewModel = ({
    dispatch,
    typingThrottle,
    onTyping,
    focusCallback,
}: ThreadSearchViewModelPros): ThreadSearchViewModel => {
    const [text, setText] = useState<string>("")
    const throttledFilter = useThrottle(text, typingThrottle)

    useEffect(() => {
        onTyping && onTyping(throttledFilter)
        dispatch(setCurrentSearchUsername(throttledFilter || null))
    }, [throttledFilter, onTyping, dispatch])

    const fh = FocusHandler(dispatch, setText, focusCallback)
    return {
        text,
        setText,
        focused: fh.focused,
        handleFocus: fh.handleFocus,
    }
}
